import { useMemo } from "react";
import useParameterApi, {
  ParameterMap,
  ParameterValueType
} from "@services/api/parameters/parameters.api";
import { Parameter } from "@services/api/parameters/parameters.types";

export default function useParameters(): ParameterMap {
  const { useGetQuery } = useParameterApi();
  const { data: fetchedParameters } = useGetQuery();

  return useMemo((): ParameterMap => {
    if (!fetchedParameters) {
      return {} as ParameterMap;
    }
    return parseParametersToObject(fetchedParameters);
  }, [fetchedParameters]);
}

function parseParametersToObject(parameters: Parameter[]): ParameterMap {
  return Object.fromEntries(
    parameters.map(({ name, value = "" }) => {
      const parsed = parseParameterValue(value);
      if (name === "languages") {
        const array = Array.isArray(parsed) ? parsed : [parsed];
        return [name, array];
      }
      return [name, parsed];
    })
  );
}

function parseParameterValue(value: string = ""): ParameterValueType {
  const trimmedValue = value.trim();

  if (trimmedValue.includes(",")) {
    return trimmedValue
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);
  }

  const lowerCasedTrimmedValue = trimmedValue.toLowerCase();
  if (lowerCasedTrimmedValue === "true") return true;
  if (lowerCasedTrimmedValue === "false") return false;

  return trimmedValue;
}
